module.exports = {"371403001":"安德街道","371403002":"临齐街道","371403101":"郑家寨镇","371403102":"糜镇","371403103":"宋家镇","371403104":"徽王庄镇","371403105":"神头镇","371403106":"滋镇","371403107":"前孙镇","371403108":"边临镇","371403109":"义渡口镇","371403110":"丁庄镇","371403202":"于集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371403.json
// module id = 1473
// module chunks = 0